import { GetAuthUrlInteractor } from './get-auth-url.interactor';
import { LoginWithRedirectAdapterInteractor } from './login-with-redirect.interactor';

export class LoginWithRedirectGenericAdapterInteractor
  implements LoginWithRedirectAdapterInteractor
{
  constructor(private readonly getAuthUrl: GetAuthUrlInteractor) {}

  public async execute(
    state: string,
    pkceChallenge: string,
    authTypeChanged: boolean,
  ): Promise<void> {
    window.location.replace(this.getAuthUrl.execute(state, pkceChallenge, authTypeChanged));
  }
}
